import './transparency.controller.js';
import './transparency.directives';
import './transparency.service.js';

import 'Sass/views/admissions-transparency.scss';